import { atom } from 'jotai';

import { loadWidget } from '@automation-suite/widget-client/lib/package';

import { widgetParamsAtom } from './widgetParamsAtom';

export const widgetAtom = atom(async (get) => {
  const widgetProps = get(widgetParamsAtom);

  return widgetProps !== undefined && widgetProps?.id && widgetProps?.variant
    ? await loadWidget({
        loaderUrl: process.env.NX_PUBLIC_WIDGET_LOADER_URL,
        ...widgetProps,
      })
    : undefined;
});
